import React from 'react';
import { connect } from 'react-redux';
import OfferContainer from './OfferContainer';
import DescriptionBlock from './DescriptionBlock';
import LinksRibbon from './LinksRibbon';

import {
  getImagePreview,
} from '../../reducers/ProductReducers';

const Landscape = ({ preview }) => {
  return (
    <div>
      { preview ?
        <img className="landscape__preview-image" width="100%" src={preview} /> :
        null
      }
      <OfferContainer />
      <LinksRibbon />
      <DescriptionBlock />
    </div>
  );
};

const mapStateToProps = ({ product }) => ({
  preview: getImagePreview(product),
});

export default connect(mapStateToProps)(Landscape);



// WEBPACK FOOTER //
// ./src/product/views/_layout/Landscape.js